import file from "file-saver";
import { usernameRegex, passwordRegex } from "./regexps";

export function filterSpaces({ value = "", regex = /\s{2,}/ }) {
  return value
    .trimStart()
    .split(regex)
    .filter((s) => s !== "")
    .join(" ");
}

export function getParams(query) {
  const params = {};

  for (const key of query.keys()) {
    params[key] = query.get(key);
  }

  return params;
}

export function getMaxDate() {
  const date = new Date();

  function toString(number) {
    return number < 10 ? `0${number}` : `${number}`;
  }

  const month = toString(date.getMonth() + 1);
  const day = toString(date.getDate());
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
}

export function getMaxReinscripcionDate() {
  const fecha = "1997-03-10";

  const year1 = new Date(fecha).getFullYear();
  const year2 = new Date().getFullYear();

  const years = [];

  for (let i = year1; i < year2; i++) {
    if (i % 5 === 0) {
      years.push(i);
    }
  }

  const lastYear = years.reverse()[0] - 1;

  return `${lastYear}-12-31`;
}

export function saveAs(data, name) {
  const blob = new Blob([JSON.stringify(data, null, 4)], {
    type: "text/plain;charset=utf-8",
  });

  file.saveAs(blob, name);
}

export function generatePassword(length = 12) {
  // return new Promise((resolve) => {
  //   let password = generator.generate({
  //     length: length,
  //     lowercase: true,
  //     uppercase: true,
  //     numbers: true,
  //     symbols: "!@#$&*",
  //     strict: true,
  //   });

  //   setTimeout(() => {
  //     resolve(password);
  //   }, 1000);
  // });

  return "";
}

export function validateUsername(username) {
  const isValidUsername = usernameRegex.test(username);

  if (!isValidUsername) {
    throw new Error(
      "Cree un nombre de usuario que tenga al menos de 6 a 20 caracteres. Solo puede contener letras, números y guión bajo."
    );
  }

  return isValidUsername;
}

export function validatePassword(password) {
  const isValidPassword = passwordRegex.test(password);

  if (!isValidPassword) {
    throw new Error(
      "Cree una contraseña que tenga al menos 8 caracteres y que al menos tenga una letra mayúscula, una letra minúscula, un número y un carácter especial."
    );
  }

  return isValidPassword;
}

export function validateMatch(password, matchPassword) {
  const isMatchPassword = password === matchPassword;

  if (!isMatchPassword) {
    throw new Error("Asegúrese de que ambas contraseñas coincidan");
  }

  return isMatchPassword;
}

export * as regexps from "./regexps";

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) {
    return "0 Bytes";
  }

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;

  const sizes = [
    "Bytes",
    "KiB",
    "MiB",
    "GiB",
    "TiB",
    "PiB",
    "EiB",
    "ZiB",
    "YiB",
  ];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export function bytesToSize(bytes) {
  const sizes = ["bytes", "KB", "MB", "GB", "TB"];

  if (bytes === 0) {
    return "0 bytes";
  }

  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

  if (i === 0) {
    return `${bytes} ${sizes[i]}`;
  }

  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
}

export function deleteSpaces(string = "") {
  return string.replace(" ", "").trim();
}
